import { normalize } from 'normalizr';
import { put, call, takeLatest } from 'redux-saga/effects';

import {
  serviceProvidersSchema,
} from '../schemas';

import {
  LOAD_SERVICE_PROVIDERS,
} from '../constants';

import {
  addOrUpdateServiceProviders,
} from './actions';

function* loadServiceProvidersWorker({ payload: response }) {
  const normalizedData = yield call(normalize, response.body, serviceProvidersSchema);

  yield put(addOrUpdateServiceProviders(normalizedData));
}

// watcher sagas

export function* loadServiceProvidersWatcher() {
  yield takeLatest(LOAD_SERVICE_PROVIDERS, loadServiceProvidersWorker);
}

// export all of the sagas.
export default [
  loadServiceProvidersWatcher(),
];



// WEBPACK FOOTER //
// ./redux/serviceProviders/sagas.js